import { Category } from 'shared/types/product/Category';
import { useFormat } from 'helpers/hooks/useFormat';
import CertNav from '../cert-nav';

interface CategoryMenuProps {
  categories: Category[];
  activeCategory: Category;
}

const CertPhysicalCardNav = ({ categories, activeCategory }: CategoryMenuProps) => {
  const { formatMessage: formatMessagePadi } = useFormat({ name: 'padi' });
  const categoryOrder = ['certification-card-type-physical', 'certification-card-special-card-physical'];
  // Using slug to define the order
  const subCategoryOrders = {
    'certification-card-type-physical': [
      'scuba-diving-certification-type-physical',
      'tecrec-certification-type-physical',
      'professional-certification-type-physical',
      'freediver-certification-type-physical',
      'mermaid-certification-type-physical',
      'efr-certification-type-physical',
      'public-safety-diver-certification-type-physical',
    ],
    'certification-card-special-card-physical': [
      'special-cards-physical-limited-edition',
      'special-cards-physical-aware-donation',
      'special-cards-physical-destinations',
    ],
  };

  const allProductText = formatMessagePadi({
    id: 'allCertPhysicalCards',
    defaultMessage: 'All Physical Cards',
  });

  return (
    <CertNav
      categories={categories}
      activeCategory={activeCategory}
      categoryId="certification-card-physical"
      isActiveECard={false}
      categoryOrder={categoryOrder}
      allProductText={allProductText}
      subCategoryOrders={subCategoryOrders}
    />
  );
};

export default CertPhysicalCardNav;
